import { redirect } from 'react-router';
import { PageRequest, isChannelSSOIntegration } from './page-request';
import { isValidEmail } from '@/utils/validation/email';
import { GetLoginMethod } from '@/connections/auth';
import { getStorageItem, setStorageItem } from '@/utils/storage/local-storage';
import { redirectIfLoggedIn } from './auth-guard';
import { redirectIfLoggedInClient } from '@/utils/auth/client-auth-guard';

function normalizeRedirect(params: PageRequest) {
  if (params.redirect_to) {
    params.redirect_uri = params.redirect_to;
    delete params.redirect_to;
  }
}

export const loader = async ({ request }: { request: Request }) => {
  const authRedirect = await redirectIfLoggedIn(request);
  if (authRedirect) return authRedirect;
  const url = new URL(request.url);
  const params = PageRequest.fromSearchParams(url.searchParams);
  return { params };
};

export const loadSignIn = async ({ request }: { request: Request }) => {
  try {
    const url = new URL(request.url);
    const params = PageRequest.fromSearchParams(url.searchParams);

    // page originally loads with a greenroom app redirect uri, set a flag in local storage
    if (params.isIOS()) {
      localStorage.setItem('from-mobile-app', 'true');
    }

    await redirectIfLoggedInClient(params);

    return { params };
  } catch (e) {
    console.error('Error loading initial data');
    console.error(e);
    throw new Error('Unknown initial load error');
  }
};

export const signInAction = async ({ request }: { request: Request }) => {
  if (request.method === 'POST') {
    const formData = await request.formData();

    // TODO if email is valid, search back-end to check if SSO is required
    // if so, direct them to the SSO page, else direct them to the password form
    const email = formData.get('email');
    const channelStr = formData.get('channel');
    const verifyPreference = getStorageItem('verifyPreference') as 'password' | 'magic-link' | undefined;
    const searchParams = PageRequest.fromSearchParams(new URL(request.url).searchParams);
    const noMagicLink = verifyPreference === 'password' || searchParams.no_magic_link === '1';

    localStorage.setItem(
      'bl#searchParams',
      JSON.stringify({
        ...searchParams.toJson(),
        exp: Date.now() + 1000 * 60 * 60, // 60 minutes
      })
    );

    if (typeof email === 'string' && isValidEmail(email)) {
      searchParams.email = email;

      const channel = typeof channelStr === 'string' ? Number(channelStr) : undefined;

      if (channel) {
        searchParams.channel = String(channel);
      }

      const authType = await GetLoginMethod(email);
      setStorageItem('user_email', email);

      if (authType.method === 'sso' && isChannelSSOIntegration(authType.config)) {
        searchParams.integration = authType.config;
        return redirect('/sign-in-sso?' + searchParams.toParams());
      }

      normalizeRedirect(searchParams);
      const path = noMagicLink ? '/password' : '/request-magic-link';
      return redirect(path + '?' + searchParams.toParams());
    }

    return { errors: { email: 'Invalid email' } };
  }
  return new Response(null, { status: 200 });
};
